import { Recurrence } from "../../types/donation/recurrence"
import { RecurrenceInterval } from "../../types/recurring-interval"

export type FixedRecurrence = 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'half-yearly' | 'yearly'
export const recurrenceIntervals: Record<FixedRecurrence, Recurrence> = {
  daily: { interval: 'day', count: 1 },
  weekly: { interval: 'week', count: 1 },
  monthly: { interval: 'month', count: 1 },
  quarterly: { interval: 'month', count: 3 },
  'half-yearly': { interval: 'month', count: 6 },
  yearly: { interval: 'year', count: 1 },
}